import {
    AGENT_GENERATION_OPTIONS,
    type AgentGenerationSelection,
} from '@apps/web/components/admin/llm_spend/constants';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@apps/web/components/ui/select';

export function GenerationSelect({
    value,
    onValueChange,
}: {
    readonly value: AgentGenerationSelection;
    readonly onValueChange: (generation: AgentGenerationSelection) => void;
}) {
    return (
        <div className="flex justify-start">
            <Select
                value={value}
                onValueChange={(next) =>
                    onValueChange(next as AgentGenerationSelection)
                }
            >
                <SelectTrigger
                    size="sm"
                    className="w-40"
                    aria-label="Agent generation"
                >
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {AGENT_GENERATION_OPTIONS.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
